/*
 * Index page section
 */

import React from "react";

const Section = ({
  id,
  children,
  className = "",
  style,
  margin = 5,
  padding = 5,
  xsPadding = 3,
  containerStyle,
}) => {
  return (
    <section
      id={id}
      className={`section-width pb-${padding} mb-${xsPadding} mb-md-${margin} ${className}`}
      style={{ ...style }}
    >
      <div className="container" style={containerStyle}>
        {children}
      </div>
    </section>
  );
};

Section.defaultProps = { background: "bg-white" };

export default Section;
